module.exports = __webpack_public_path__ + "static/assets/63d2e079277bcbde8fdd6a40d4c0047a.svg";